module.exports = __webpack_public_path__ + "static/media/rotate-anticlockwise-icon.f5696dd9.png";